import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  mail_to: Yup.string()
    .required('Email is required')
    .test('is-valid-email', 'Invalid email format', function (value) {
      if (!value) return false;
      const parts = value.split('@');
      if (parts.length !== 2) return false;
      const domain = parts[1];
      return domain.includes('.') && domain.split('.').every(p => p.length > 0);
    }),
});

export const ValidateEmail = async (email) => {
  try {
    await validationSchema.validate({ mail_to: email });
    //console.log('Email is valid:', email);
    return true;
  } catch (err) {
   // console.log('Email validation error:', err.message);
    return false;
  }
};
  
  export const ScrollToViewFirstError = (newErrors) => {
    
    if (Object.keys(newErrors).length !== 0) {
      const errorField = Object.keys(newErrors)[0];
      const errorElement = document.getElementById(errorField);
      if (errorElement) {
          const elementPosition = errorElement.getBoundingClientRect().top + window.pageYOffset;
          const offset = 100; 
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'auto'
        });
      }
    }
  }

  export const DateConvert = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  export const DateConvertWithTime = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const StripHtmlAndTruncate = (text, wordLimit = 55) => {
  if (!text) return { truncated: "", isTruncated: false, fullText: "" };

  // Strip HTML tags and replace common entities
  const strippedText = text.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ').replace(/_/g, ' ');

  const words = strippedText.split(/\s+/).filter(Boolean);
  if (words.length > wordLimit) {
    return {
      truncated: words.slice(0, wordLimit).join(' ') + '...',
      isTruncated: true,
      fullText: strippedText
    };
  }

  return {
    truncated: strippedText,
    isTruncated: false,
    fullText: strippedText
  };
};

  export const floorTo = (num, decimals = 2) => {
  if (num === null || num === undefined || isNaN(num)) return 0;

  const factor = 10 ** decimals;
  return Math.floor((Number(num) + Number.EPSILON) * factor) / factor;
};



